require('./bootstrap4');
require('alpinejs');
require('./trumbowyg.min');
require('select2');

$('body').on('click','.delete',function (e) {
    e.preventDefault();// Don't post the form, unless confirmed
    if (confirm('Certeza que deseja excluir este registro?')) {
        // Post the form
        $(e.target).closest('form').submit() // Post the surrounding form
    }
});

$('body').on('click','.inativar',function (e) {
    e.preventDefault();// Don't post the form, unless confirmed
    if (confirm('Certeza que deseja Inativar este registro?')) {
        // Post the form
        $(e.target).closest('form').submit() // Post the surrounding form
    }
});

$('.selectize').select2({
    placeholder: "SELECIONE UMA OPÇÃO",
    width : '100%',
    selectOnClose: true
});

$(document).on('select2:open', () => {
    document.querySelector('.select2-search__field').focus();
});

$('select.select2').on('select2:closing', function (e) {
    $(e.target).data("select2").$selection.one('focus focusin', function (e) {
        e.stopPropagation();
    });
});

$('#unidade_id').on('change',function(){
    var go = $(this).data('url');
    var data = $('input[name="data"]').val();
    window.location = window.location.origin+go+'?unidade_id='+$(this).val()+'&data='+data;
});

// $('#productionGo').on('submit',function (e) {
//     var total = [];
//     var nomes = [];
//     var servs = [];
//     var ids = [];
//     var geral1 = 0;
//     var geral2= 0;
//     var msg = '';
//     $(".sum").each(function() {
//         var s = $(this).data('s');
//         geral1 = geral1 + parseInt($(this).val());
//
//         // if(total[s]){
//         //     total[s] = total[s] + parseInt($(this).val());
//         // }  else {
//         //     total[s] =  parseInt($(this).val());
//         // }
//     });
//
//     $(".servs").each(function() {
//         geral2 = geral2 + parseInt($(this).val());
//         // var refs =  $(this).data('ref');
//         // jQuery.each(refs, function(key, v) {
//         //     nomes[v] = $(this).data('nome');
//         //     if(servs[v]){
//         //         servs[v] = servs[v] + parseInt($(this).val());
//         //     }  else {
//         //         servs[id] =  parseInt($(this).val());
//         //     }
//         // });
//         // nomes[id] = $(this).data('nome');
//         // if(servs[id]){
//         //     servs[id] = servs[id] + parseInt($(this).val());
//         // }  else {
//         //     servs[id] =  parseInt($(this).val());
//         // }
//     });
//
//     // jQuery.each(ids, function(key, v) {
//     //     if(total[v] == servs[v]){
//     //
//     //     } else {
//     //         if(v > 0){
//     //             e.preventDefault();
//     //             msg += nomes[v]+" têm quantidades divergentes \n";
//     //         }
//     //     }
//     // });
//     //
//     // if(msg.length > 3){
//     //     e.preventDefault();
//     //     alert(msg);
//     // }
//
//     if(geral1 == geral2){
//
//     } else {
//         e.preventDefault();
//         alert('quantidades gerais não conferem com quantidades especificas, Geral: '+geral2+' especifica:'+geral1);
//         el.find("button[type='submit'],input[type='submit']").prop('disabled',false);
//     }
//
// });

$(document).ready(function () {
    $('form').submit(function() {
        var el = $(this);
        el.find("button[type='submit'],input[type='submit']").prop('disabled',true);
        $('select').removeAttr('disabled');
        setTimeout(function(){el.prop('disabled', false); }, 5000);
    });
    $('textarea#editorHtml').trumbowyg();
});

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$('#changeForn').on('change',function(){
    var go = $(this).data('url');
    window.location = window.location.origin+go+'?fornecedor_id='+$(this).val();
});

$('body').on('click','.copyLink',function () {
    var link = $(this).data('link');
    copiarLink(link);
});

$('body').on('click','.gerarLink',function () {
    var url = $(this).data('link');
    var el = $(this);
    $.ajax({
        type: "GET",
        url: url,
        async: true,
        cache: false,
        success: function (data, status) {
            if(data){
                el.attr('title','Copiar Link funcionarios');
                el.attr('data-link',data);
                el.removeClass('gerarLink');
                el.addClass('copyLink');
                copiarLink(data);
            } else {
                alert('necessário informar empresa no cadastro de unidade');
            }
        }
    });
});

function copiarLink(link)
{
    var $body = document.getElementsByTagName('body')[0];
    var $tempInput = document.createElement('INPUT');
    $body.appendChild($tempInput);
    $tempInput.setAttribute('value',  link);
    $tempInput.select();
    document.execCommand('copy');
    $body.removeChild($tempInput);
    alert('Link copiado : '+link);
}

const tabs = document.querySelectorAll(".tabs");
const tab = document.querySelectorAll(".tab");
const panel = document.querySelectorAll(".tab-content");

function onTabClick(event) {

    // deactivate existing active tabs and panel

    for (let i = 0; i < tab.length; i++) {
        tab[i].classList.remove("active");
    }

    for (let i = 0; i < panel.length; i++) {
        panel[i].classList.remove("active");
    }


    // activate new tabs and panel
    event.target.classList.add('active');
    let classString = event.target.getAttribute('data-target');
    // console.log(classString);
    document.getElementById('panels').getElementsByClassName(classString)[0].classList.add("active");
}

for (let i = 0; i < tab.length; i++) {
    tab[i].addEventListener('click', onTabClick, false);
}

$('#documentoAdd').on('click', function(){
    var files = document.getElementById('filesDocs').files;
    var ajaxData = new FormData();
    var base_link = $('#baseLink').val();
    ajaxData.append( 'tipos',$('#tiposDocs').val());
    ajaxData.append( 'funcionario_id',$('#funId').val());
    jQuery.each(files, function(i, file) {
        ajaxData.append('arquivo['+i+']', file);
    });

    $.ajax({
        url: "/funcionarios/upDocs",
        data: ajaxData,
        cache: false,
        contentType: false,
        processData: false,
        type: 'POST',
        success: function(data) {
            if (data == '') {
                alert('Formato de Arquivo invalido.');
            } else {
                jQuery.each(data, function(i, d) {
                    let tr = '<tr>' +
                        '<td>---</td>' +
                        '<td>' + d.tipo_show + '</td>' +
                        '<td>' + d.arquivo + '</td>' +
                        '<td>' +
                        '   <a class="edit" target="_blank" href="' + base_link + '/' + d.arquivo + '">Ver Arquivo </a>' +
                        '   <a data-id="' + d.id + '" class="delete2" href="javascript:;">Apagar </a>' +
                        '</td>' +
                        '</tr>';
                    $(tr).insertBefore('#tableDocs table > tbody > tr:first');
                    $('#tiposDocs').val('');
                    $('#filesDocs').val('');
                });
            }
        }
    });
});

$('#tableDocs').on('click','.delete2',function(){
    var id = $(this).data('id');
    var tr = $(this).closest('tr');
    $.ajax({
        url: "/funcionarios/remove-doc/"+id,
        cache: false,
        type: 'GET',
        success: function(data) {
            if(data == 'ok'){
                tr.remove();
            } else{
                alert('ocorreu um erro ao tentar excluir este documento, tente novamente');
                console.log(data);
            }
        }
    });
});

$('#atestadoTb').on('click','.delete2',function(){
    var id = $(this).data('id');
    var tp = $(this).data('tp');
    var tr = $(this).closest('tr');
    $.ajax({
        url: "/atestados/remove-doc/"+id+'/'+tp,
        cache: false,
        type: 'GET',
        success: function(data) {
            if(data == 'ok'){
                tr.remove();
            } else{
                alert('ocorreu um erro ao tentar excluir este documento, tente novamente');
                console.log(data);
            }
        }
    });
});

$('body').on('click','.addRow',function(){
    var table = $(this).closest('table');
    var tr = $(this).closest('tr').clone();
    tr.find('input').val('');
    tr.find('select').val('');
    tr.appendTo(table).show('slow');
    $(".money").maskMoney({prefix:'R$ ', allowNegative: true, thousands:'.', decimal:',', affixesStay: false});
});

$('body').on('click','.removeRow',function(){
    var tr = $(this).closest('tr').remove();
});

$('body').on('click','.removeLog',function(){
    var id = $(this).data('id');
    var tr = $(this).closest('tr');
    $.ajax({
        url: "/funcionarios/remove-log/"+id,
        cache: false,
        type: 'GET',
        success: function(data) {
            if(data == 'ok'){
                tr.remove();
            } else{
                alert('ocorreu um erro ao tentar excluir este documento, tente novamente');
                console.log(data);
            }
        }
    });
});

$(document).ready(function () {
    $('.travar').on('click', function(){
        $('#travar').val('s');
    });
    $('form').submit(function() {
        var el = $(this);
        el.find("button[type='submit'],input[type='submit']").prop('disabled',true);
        $('select').removeAttr('disabled');
        setTimeout(function(){el.prop('disabled', false); }, 5000);
    });
    $('.calc').on('keyup', function(){
        var geral = 0;
        $('.trCheck').each(function(){
            var total = 0;
            var dias = $(this).children("td:nth-child(2)").find('input').val();
            var qtd = $(this).children("td:nth-child(3)").find('input').val();
            var valor = $(this).children("td:nth-child(4)").find('input').maskMoney('unmasked')[0];
            total = total + parseFloat(dias * qtd * valor);
            geral = geral + parseFloat(total);
            $(this).children("td:nth-child(5)").text(dinheiro(total));
        });
    });
    $('.calc2').on('keyup', function(){
        var dias = $('#dias').val();
        var qtd = $('#qtd').val();
        var valor = $('#valor').val();
        $('.bg-red-500').val(dinheiro(dias*qtd*valor));
    });
});

dinheiro = function(v){
    return v.toLocaleString( 'pt-Br',{minimumFractionDigits: 2 , maximumFractionDigits: 2 ,style: 'currency', currency: 'BRL'});
};

$(function(){
    $("ul.checktree").checktree();
});
(function($){
    $.fn.checktree = function(){
        $(':checkbox').on('click', function (event){
            event.stopPropagation();
            var clk_checkbox = $(this),
                chk_state = clk_checkbox.is(':checked'),
                parent_li = clk_checkbox.closest('li'),
                parent_uls = parent_li.parents('ul');
            parent_li.find(':checkbox').prop('checked', chk_state);
            parent_uls.each(function(){
                parent_ul = $(this);
                parent_state = (parent_ul.find(':checkbox').length == parent_ul.find(':checked').length);
                parent_ul.siblings(':checkbox').prop('checked', parent_state);
            });
        });
    };
}(jQuery));

$('#funcionario_id').on('change', function () {
   var fid = $(this).val();
   var nc = $('#nc').val();
   if(fid > 0 && nc != ''){
       getRiscosExames(fid,nc)
   } else{
       alert('necessario informar NC e Funcionario!');
   }
});

$('#nc').on('change',function () {
    var fid = $('#funcionario_id').val();
    var nc = $(this).val();
    if(fid > 0){
        getRiscosExames(fid,nc)
    }
    if(nc == 'n'){
       $('.pxAso').show();
    } else{
        $('.pxAso').hide();
    }
});

function getRiscosExames(fid,nc) {
    nc = nc == 'n' ? 2 : 1;
    var url = '/asos/'+fid+'/'+nc+'/funcionario';
    $('.loadRiEx').load(url);
}

$('.checkCpf').on('blur', function () {
    var cpf = $(this).val();
    $.ajax({
        url: "/funcionarios/"+cpf+"/check-cpf",
        cache: false,
        type: 'GET',
        success: function(data) {
            if(data){
                alert('esse funcionario ja possui cadastro em nosso sistema, com ID:: '+data);
            }
        }
    });
});

$('body').on('blur','.aplyTodos', function (){
    $('.funcLog').val($(this).val());
});

$("input").not($(":button")).keypress(function (evt) {
    if (evt.keyCode == 13) {
        iname = $(this).val();
        if (iname !== 'Submit') {
            var fields = $(this).parents('form:eq(0),body').find('button, input, textarea, select');
            var index = fields.index(this);
            if (index > -1 && (index + 1) < fields.length) {
                fields.eq(index + 1).focus();
            }
            return false;
        }
    }
});
